<template lang="html">
    <div
        :class="[
            `vs-progress-${backgroundColor || color}`,
            {
                indeterminate: indeterminate
            }
        ]"
        :style="styleConProgress"
        class="vs-progress--background"
    >
        <div class="overlay" :style="{ height: `${this.height}px` }">
            <slot></slot>
        </div>
        <div
            :style="styleProgress"
            :class="[`vs-progress-${color}`]"
            class="vs-progress--foreground"
        />
        <div v-if="indeterminate" :style="styleProgress" class="vs-progress--indeterminate" />
    </div>
</template>

<script>
import _color from '@/assets/utils/color.js'
export default {
    name: 'vx-progress',
    props: {
        height: {
            type: [Number, String],
            default: 5
        },
        indeterminate: {
            type: Boolean,
            default: false
        },
        percent: {
            type: Number,
            default: 0
        },
        color: {
            type: String,
            default: 'primary'
        },
        opacity: {
            type: [Number, String],
            default: 1
        },
        backgroundColor: {
            type: String
        },
        backgroundOpacity: {
            type: [Number, String],
            default: 0.1
        }
    },
    data() {
        return {
            percentx: 0
        }
    },
    computed: {
        styleConProgress() {
            var bgColor = this.backgroundColor
            if (!bgColor) {
                bgColor = _color.getColorString(this.color, this.backgroundOpacity)
            }

            var test = {
                background: `${bgColor} !important`,
                height: `${this.height}px`
            }

            if (!bgColor.startsWith('rgba')) {
                test['background-opacity'] = '0.1 !important'
            }
            return test
        },
        styleProgress() {
            var foregroundColor = _color.getColorString(this.color, this.opacity)
            return {
                background: foregroundColor,
                width: `${this.percentx}%`
            }
        }
    },
    watch: {
        percent(val) {
            this.setPercentage(val)
        }
    },
    methods: {
        setPercentage() {
            if (!this.percent) {
                this.percentx = 0
                return
            }
            this.percentx = this.percent < 100 ? this.percent : 100
        }
    },
    mounted() {
        setTimeout(() => {
            this.setPercentage() // to force animation
        }, 50)
    }
}
</script>

<style lang="scss" scoped>
.overlay {
    position: absolute;
    width: 100%;
}
.vs-progress--foreground,
.vs-progress--background {
    transition: all 0.2s;
    overflow: visible;
    // &:hover {
    //     transform: scaleY(1.3);
    // }
}
</style>
